import styled from 'styled-components';
import { fontSize, fontWeight } from 'modules/theme';
import { themeGet } from 'modules/v2';
import { unit, padding, marginBottom, margin, marginLeft, pxToRem } from 'modules/v2/foundation/spacing';
import { interactiveTransition } from 'modules/v2/foundation/theme';
export const backgroundColorFromProps = (props) => {
    if (props.disabled) {
        return themeGet('colors.gray.50');
    }
    if (props.$selected) {
        return themeGet('colors.primary.400');
    }
    return themeGet('colors.primary.50');
};
export const colorFromProps = (props) => {
    if (props.disabled) {
        return themeGet('colors.gray.400');
    }
    if (props.$selected) {
        return themeGet('colors.gray.0');
    }
    return themeGet('colors.primary.800');
};
export const Container = styled.button `
  ${padding(0, 4)}
  ${margin(0)}
  ${fontSize('base')};
  ${fontWeight('semibold')};
  display: flex;
  appearance: none;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  cursor: ${(props) => (props.disabled ? 'default' : 'pointer')};
  width: 100%;
  height: ${unit(20)};
  background-color: ${backgroundColorFromProps};
  border: ${pxToRem(1)} solid transparent;
  border-radius: ${themeGet('borderRadius.md')};
  color: ${colorFromProps};
  text-align: left;
  ${interactiveTransition};

  &:not(:last-child) {
    ${marginBottom(4)};
  }

  ${(props) => !props.disabled &&
    `
      &:hover {
        background-color: ${props.$selected ? themeGet('colors.primary.400') : themeGet('colors.primary.200')};
        color: ${props.$selected ? themeGet('colors.primary.800') : undefined};
      }

      &:focus-visible {
        border-color: ${props.$selected ? themeGet('colors.primary.500') : themeGet('colors.primary.400')};
        outline: 0;
      }
    `}
`;
export const IconContainer = styled.div `
  ${marginLeft(4)};
  pointer-events: none;
`;
